import React from 'react'
import { FormikProps } from 'formik'
import { EditionType } from '@graphics/gfx-common/dist/constants'
import { PackType, IEditionMetadata, IPackInput } from '../../types/pack'
import { getPreviewImages } from '../../services/pack'
import { showPasteImageFieldForEdition } from '../../services/capabilitiesSummary'
import { DetailsTemplate } from '../../layouts'
import { UpdateDataFileForm } from '../../forms'
import {
  H2,
  FileUploadZone,
  PreviewPicture,
  DisabledUploadHint,
} from '../../components'

export interface IEditionUploadTab {
  edition: IEditionMetadata
  pack: PackType
  formikProps: FormikProps<IPackInput>
}

export const EditionUploadTab = ({
  edition,
  pack,
  formikProps,
}: IEditionUploadTab) => {
  if (edition.editionType === EditionType.DataStreamData) {
    return (
      <UpdateDataFileForm
        edition={edition}
        pack={pack}
        packFormDirty={formikProps.dirty}
      />
    )
  }
  const isDataStreamGraphic =
    edition.editionType !== EditionType.DataStreamGraphic
  const { previewURI = '' } = getPreviewImages(
    edition.useGraphicPreview ? pack : edition
  )
  const uploadDisabled = pack.publishing?.publishing || formikProps.dirty
  return (
    <>
      <DetailsTemplate
        aside={
          isDataStreamGraphic && (
            <>
              <H2 mb={4}>Upload files</H2>
              <DisabledUploadHint packFormDirty={formikProps.dirty} />
              <FileUploadZone
                id={`file-input-${edition.id}`}
                currentEdition={{ ...edition, exact: true }}
                disabled={uploadDisabled}
                groupId={pack.group}
                allowPastingImages={showPasteImageFieldForEdition(edition)}
              />
            </>
          )
        }
        contentProps={{ id: 'edition-upload-tab-main' }}
        asideProps={{ id: 'edition-upload-tab-aside' }}
      >
        <H2 mb={4}>Preview image</H2>
        <PreviewPicture
          width="500px"
          height="calc(100% - 50px)"
          size="500px"
          src={previewURI}
        />
      </DetailsTemplate>
    </>
  )
}
